import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NextGenTvAsset } from 'src/models/nextgen-tv-asset.model';
import { MediaService } from 'src/services/media.service';

@Component({
  selector: 'app-video-embed',
  templateUrl: './video-embed.component.html',
  styleUrls: ['./video-embed.component.scss'],
})
export class VideoEmbedComponent implements OnInit {
  @Input() streamingAssetId: any;
  asset: NextGenTvAsset;
  videoPlayerOptions: any;
  isLoading = false;
  constructor(
    private mediaService: MediaService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.route.queryParamMap.subscribe((map) => {
      this.streamingAssetId = map.get('streamingId');
      if (this.streamingAssetId) {
        this.getAsset();
      }
    });
  }

  private getAsset() {
    this.isLoading = true;
    this.mediaService
      .getStreamingAsset(this.streamingAssetId)
      .then((asset) => {
        console.log('asset retrieved', asset);
        this.asset = asset;
        this.initVideoPlayer();
        console.log('video player initialized');
      })
      .finally(() => (this.isLoading = false));
  }

  private initVideoPlayer() {
    if (this.asset) {
      let sources = [] as any;
      if (this.asset) {
        sources = [
          {
            src: this.asset.manifestUrlHls as string,
            type: 'application/x-mpegURL',
          },
          {
            src: this.asset.manifestUrlDash as string,
            type: 'application/dash+xml',
          },
        ];
      }

      this.videoPlayerOptions = undefined as any;

      setTimeout(() => {
        this.videoPlayerOptions = {
          autoplay: false,
          fluid: true,
          controls: true,
          sources: sources,
        };
      }, 200);
    }
  }
}
